import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-product-display-zone',
  templateUrl: './modify-product-display-zone.component.html',
  styleUrls: ['./modify-product-display-zone.component.css']
})
export class ModifyProductDisplayZoneComponent implements OnInit {

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) {

  }

  cProductList: any= []
  zoneName:any = ""
  noOfProductsPerLine:any = ""
  cid:any;
  done:any = [];

  productDisplayZoneList: any= []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleProductDisplayZoneData: any= []
  isEdit = false;

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid');
    this.getallproduct()
    this.getAllProductDisplayZone()
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  getallproduct(){
    this.generic_service.getAllProducts().subscribe(
      (response:any)=>{
        console.log(response)
        console.log(this.done)

        this.cProductList = [];
        for(let i=0; i<response.response.length;i++){
       
          let body = {
            "slNo": 0,
            "productId": response.response[i].productMasterId,
            "code": response.response[i].code,
            "name": String(response.response[i].name),
            "group": String(response.response[i].group),
            "description": String(response.response[i].description),
            "imageUrl": String(response.response[i].imageUrl),
            "sku": ""
          }
          this.cProductList.push(body)
        }      
      }
    )
  }

  // getAllCProduct(){
  //   this.generic_service.getAllcProductMaster().subscribe(
  //     (response:any)=>{
  //       console.log(response);
  //       this.cProductList = [];

  //       for(let i=0; i<response.response.length;i++){
  //         let body = {
  //           "slNo": 0,
  //           "productId": response.response[i].cproductId,
  //           "code": response.response[i].code,
  //           "name": String(response.response[i].name),
  //           "group": String(response.response[i].group),
  //           "description": String(response.response[i].description),
  //         }
  //         this.cProductList.push(body)
  //       }
  //     }
  //   )
  // }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllProductDisplayZone();
  }

  getAllProductDisplayZone(){
    this.generic_service.getAllProductDisplayZone().subscribe(
      (response:any)=>{
        console.log(response);
        this.productDisplayZoneList = response.response
      }
    )
  }

  getProductDisplayZoneById(productDisplayZoneById:any){
    this.generic_service.getProductDisplayZoneById(productDisplayZoneById).subscribe(
      (res:any)=>{
        console.log(res)
        this.done = []
        this.zoneName = res.response.zoneName
        this.noOfProductsPerLine = res.response.noOfProductsPerLine
        this.done = res.response.productInfoObjList;

        this.singleProductDisplayZoneData.push(res.response)
        this.isEdit = true;

      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  editProductDisplayZone(){

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": this.singleProductDisplayZoneData[0].id,
      "displayZoneId": this.singleProductDisplayZoneData[0].displayZoneId,
      "seqNo": 0,
      "slNo": 0,
      "zoneName": this.zoneName,
      "productInfoObjList": this.done,
      "cid": this.singleProductDisplayZoneData[0].cid,
      "noOfProductsPerLine": Number(this.noOfProductsPerLine)
    }

    let body1 = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": this.singleProductDisplayZoneData[0].id,
      "displayZoneId": this.singleProductDisplayZoneData[0].displayZoneId,
      "seqNo": 0,
      "slNo": 0,
      "zoneName": this.zoneName,
      "productInfoObjList": this.done,
      "cid": this.singleProductDisplayZoneData[0].cid,
      "noOfProductsPerLine": Number(this.noOfProductsPerLine)
    }
    console.log(body1)
    this.generic_service.editProductDisplayZone(body1).subscribe(
      (response:any)=>{
        console.log(response)
        this.getallproduct()
        this.done = [];
        this.toastr.success(response.message)
        this.closeEdit()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  } 

  closeEdit() {
    this.isEdit = false;
  }

}
